import { useSpecialtyParams } from '@medifind/hooks';
import { Skeleton } from '@medifind/shared-basic-components';
import { getValueMediaBreakpointDown } from '@medifind/utils';
import { useRouteStore } from '@medifind/zustand';
import { HeadingBox } from './components';
import styles from './SpecialtyBox.module.scss';

/* __ROUTE_PATH__=/specialty/:specialtySlug/:rest* */
const SpecialtyBox = () => {
  const { pageTitle, pageDescription } = useRouteStore((state) => state?.params?.specialty || {});

  useSpecialtyParams();

  return (
    <HeadingBox
      smallAt="md"
      topRowChildren={
        <div style={{ flex: 1, marginRight: '1rem', marginBottom: '1rem' }}>
          <h1 className={styles['splash-title']}>
            {pageTitle ? (
              <span
                dangerouslySetInnerHTML={{
                  __html: pageTitle.replace(/ ([a-z]{1,3})$/, '&nbsp;$1'),
                }}
              ></span>
            ) : (
              <Skeleton height={getValueMediaBreakpointDown({ xs: 30, sm: 30 })} count={getValueMediaBreakpointDown({ xs: 4, sm: 3 })} />
            )}
          </h1>
          <div className={styles['splash-text']}>
            {pageDescription ? (
              <span
                dangerouslySetInnerHTML={{
                  __html: pageDescription,
                }}
              ></span>
            ) : (
              <Skeleton count={getValueMediaBreakpointDown({ xs: 9, sm: 5 })} />
            )}
          </div>
        </div>
      }
    />
  );
};

export { SpecialtyBox as default, SpecialtyBox };
